import * as React from "react"
import * as ClientOAuth2 from "client-oauth2";
import { App } from "./app"
import { Assert } from "./PADebug"
import { PADebug } from "./PADebug"
import { PAVersion } from "./BDKalkCore"
import { SelectionSetGW } from "./SelectionSetGW"
import { BDKalkCore } from "./BDKalkCore"
import { ProjectItem } from "./ProjectItem"
import { ArticleGW } from "./ArticleGW"   
import { BuildPartGW } from "./BuildPartGW"
import { BuildPartItem } from "./BuildPartItem"
import { BuildPartQRItem } from "./BuildPartQRItem"
import { BuildPartSet } from "./BuildPartSet"

///////  Reading json files /////////

// GetFromUrl - loads a string from an url
function GetFromUrl(url: string) {
    alert("GetFromUrl called!!")
    var Httpreq = new XMLHttpRequest(); // a new request
    Httpreq.open("GET", url, false);

    try {
        Httpreq.send(null);
    }

    catch (e) {
        alert("GetFromUrl() - error: Httprequest failed!  Requested url was: \"" + url + "\"")
    }

    return Httpreq.responseText;
}

// LoadFromUrl - also loads a string, though it won't wait for the result but takes an event handler instead
function LoadFromUrl(url: string, onloaded: (s: string) => void, token: ClientOAuth2.Token) {
    var Httpreq = new XMLHttpRequest(); // a new request
    Httpreq.open("GET", url, true);
    Httpreq.setRequestHeader("Authorization", "Bearer " + token.accessToken);
    Httpreq.setRequestHeader("Content-Type", "application/json");
    Httpreq.addEventListener("load", () => onloaded(Httpreq.responseText));
    Httpreq.send(null);
}

// Posting json files
function SaveToUrl(url: string, selectionId:string | null, onSaved: (response: string) => void, token: ClientOAuth2.Token, content:SelectionSetGW) {
    var Httpreq = new XMLHttpRequest(); // a new request
    Httpreq.open("POST", url, true);
    Httpreq.setRequestHeader("Authorization", "Bearer " + token.accessToken);
    Httpreq.setRequestHeader("Content-Type", "application/json");
    Httpreq.addEventListener("load", () => onSaved(Httpreq.responseText));
    var contentSet: { id: string, name: string, meta: string } = { id: "", meta: content.GetMeta(), name: content.GetName() }
    Httpreq.send(JSON.stringify(content.GetSet()));
}

///////////////   SelectionSetManagerGW  ////////////////
export class SelectionSetManagerGW {
    
    constructor(serverUrl: string) {
        this.m_serverUrl = serverUrl;
        this.m_currentProjectName = ""
        this.m_currentBuildPartName = ""
        this.m_currentProjectSummaryName = ""
        this.m_version = PAVersion
        this.m_hoveredBuildPartIndex = -1
        this.m_hoveredProjectIndex = -1
        this.m_qrid = null
        this.m_isProjectNameSet = false
    }

    // Saves a selection set to the server
    public SaveSelectionSet(selection: SelectionSetGW, selectionId: string | null, onSaved: (id: string) => void) {
        if (PADebug.IsDebuging()) {
            this.m_core.DebugIncrementSelectionSetSaveCalls()
        }

        SaveToUrl(this.m_serverUrl + "api/selection", selectionId, onSaved, this.GetAccessToken(), selection)
    }

    // Returns the access token from the user login
    public GetAccessToken() {
        return this.m_accessToken
    }

    // Sets the access token from the user login
    public SetAccessToken(token: ClientOAuth2.Token) {
        this.m_accessToken = token
    }

    // sets the reference back to the core upon creation
    public InitCore(core: BDKalkCore) {
        this.m_core = core
        // this.m_deletionArticle = core.GetDeletionDummy() // this will return a nonsense article selection for replacing a deleted set
    }

    // Upon opening a new project, sets the current project name to New project, but with the addition (1), (2) ...and so on if a project
    // was saved already with that same name, so that overwriting the previous won't happen as easily by mistake 
    public SetCurrentProjectNameToNew() {

        var chosenNumber = 1
        const nameBase = "Nytt utvalg"
        var newName: string
        var nameIsGood : boolean

        for (; true ; chosenNumber++) {
            newName = nameBase
            nameIsGood = true

            if (chosenNumber > 1) {
                newName += ("(" + chosenNumber.toString() + ")")
            }

            for (var p = 0; p < this.m_projects.length; p++) {
                if (this.m_projects[p].GetName() == newName) {
                    nameIsGood = false
                    break
                }
            }

            for (var b = 0; b < this.m_buildParts.length; b++) {
                if (this.m_buildParts[b].GetName() == newName) {
                    nameIsGood = false
                    break
                }
            }

            if (nameIsGood == true) {
                this.SetCurrentProjectName(newName)
                this.m_core.GetApp().forceUpdate()
                break
            }
        }
    }

    /* OnAccountDataLoaded is called one time directly upon a successful login, and provides with data for
     * the saved projects, favorites and building parts. */
    OnAccountDataLoaded(data: string) {
        var obj: [{ id: string, name: string, meta: string, created:string, modified:string }] = JSON.parse(data)
        var set: SelectionSetGW 

        this.m_buildParts = new Array<SelectionSetGW>()
        this.m_projects = new Array<SelectionSetGW>()
        this.m_favorites = null
        
        // Filling up m_sets
        for (var i = 0; i < obj.length; i++) {
            set = new SelectionSetGW()
            set.SetId(obj[i].id)
            set.SetName(obj[i].name)
            set.SetMeta(obj[i].meta)
            set.SetTimeData(obj[i].created, obj[i].modified)
            
            // Separating favorites, build parts and projects
            Assert(set.GetMeta().length >= 6, "SelectionSetManagerGW:OnAccountDataLoaded - the meta data of the loaded selection set was not in proper format!")
            
            if (obj[i].meta.charAt(0) == 'P') { // P: project
                this.m_projects.push(set)
            }
            
            if (obj[i].meta.charAt(0) == 'B') { // B: Building part
                this.m_buildParts.push(set)
            }

            if (obj[i].meta.charAt(0) == 'F') { // F: Favorites
                this.m_favorites = set
            }

            if (obj[i].meta.charAt(0) == 'H') { // H: Hurtigrapport
                this.m_qrid = set.GetId()
            }
        }

        // Now the loaded projects will be filtered so that only the latest saved version will be used
        var refined = new Array<SelectionSetGW>()
        var test: string
        var found: boolean

        for (var i = 0; i < this.m_projects.length; i++) {
            test = this.m_projects[i].GetName()
            found = false

            for (var j = i + 1; j < this.m_projects.length; j++) {
                if (this.m_projects[j].GetName() == test) {
                    found = true
                    break
                }
            }

            if (found == false) {
                Assert(this.m_projects[i].GetMeta().length >= 6, "SelectionSetManagerGW:OnAccountDataLoaded - the meta data of one selection set was not in proper format!")
                
                if (this.m_projects[i].GetMeta().charAt(1) != 'D') {
                    refined.push(this.m_projects[i])
                }
            }
        }

        this.m_projectsUnRefined = this.m_projects
        this.m_projects = refined

        // In the same way the build parts will be filtered to only use the latest saved version of it..
        var refinedBP = new Array<SelectionSetGW>()

        for (var i = 0; i < this.m_buildParts.length; i++) {
            test = this.m_buildParts[i].GetName()
            found = false

            for (var j = i + 1; j < this.m_buildParts.length; j++) {
                if (this.m_buildParts[j].GetName() == test) {
                    found = true
                    break
                }
            }

            if (found == false) {
                Assert(this.m_buildParts[i].GetMeta().length >= 6, "SelectionSetManagerGW:OnAccountDataLoaded - the meta data of one selection set was not in proper format!")

                if (this.m_buildParts[i].GetMeta().charAt(1) != 'D') {
                    refinedBP.push(this.m_buildParts[i])
                }
            }
        }

        this.m_buildPartsUnRefined = this.m_buildParts
        this.m_buildParts = refinedBP

        // Processing favorites
        if (this.m_favorites != null) {
            LoadFromUrl(this.m_serverUrl + "api/selection/" + this.m_favorites.GetId() + "/complete", this.onLoadedFavorites.bind(this), this.m_accessToken)
        }
        else {
            Assert(false, "manager.OnAccountDataLoaded - favorites set was missing!")
        }
        
        // Build parts should now be loaded fully as build part objects (with their owned articles loaded) which will be a loading process happening in the background until ready.
        this.m_core.LoadBuildParts(refinedBP, refined)
    }

    // 
    onLoadedFavorites(incomingData: string) {
        this.m_core.onFavoritesLoad(incomingData)

        if (this.m_isProjectNameSet == false) {
            this.m_isProjectNameSet = true
            this.SetCurrentProjectNameToNew()
        }
    }

    // 
    ReloadAccountData() {
        this.m_core.LoadAccountData(null)
    }

    // 
    GetProjectAmount() {
        return this.m_projects.length
    }

    // 
    public RenderProjects(startPos: number, endPos:number) {
        var elements: Array<JSX.Element> = new Array<JSX.Element>() // A holder to the project items that will be displayed
        var key = 0
        var summaries = this.m_core.GetProjectSummaries()
        var summaryRef: BuildPartGW | null

        for (var i = startPos; (i < this.m_projects.length) && (i < endPos) ; i++) {
            const ind = i
            const pro = this.m_projects[i]
            const keyStr = key.toString()

            summaryRef = null
            for (var j = 0; j < summaries.length; j++) {
                if (summaries[j].GetTitle() == this.m_projects[i].GetName()) {
                    summaryRef = summaries[j]
                    break
                }
            }

            const sRef = summaryRef

            elements[key++] = <ProjectItem key={keyStr} proRef={pro} proSummary={sRef} core={this.m_core} index={ind} />
            // elements.push(<div> Prosjekt: {this.m_projects[i].GetName()} meta:{this.m_projects[i].GetMeta()} id:{this.m_projects[i].GetId()}} </div>)
        }
        
        return elements
    }
    
    /* Renders the build parts as they should be displayed in the build parts view, were you 
     * can load them in various ways, edit or delete them from the account permanently */
    public RenderBuildParts(startPos:number, endPos:number) {
        var elements: Array<JSX.Element> = new Array<JSX.Element>() // A holder to the build part items that will be displayed
        var key = 0
        
        for (var i = startPos; (i < this.m_core.GetBuildParts().length) && (i < endPos); i++ , key++) {
            const ind = i
            const pro = this.m_core.GetBuildParts()[i]
            const keyStr = key.toString()
            elements.push(<BuildPartItem key={keyStr} core={this.m_core} buildPart={pro} index={ind} />)
        }
        
        return <div>
            <div>{elements}</div>
        </div>
    }

    /* Renders build parts as they should be displayed in the selection view, where you can change their amounts, remove them from selection etc.
     * Only the build parts added to the list of selected buildparts for the current selection will be displayed, if none this will return an empty <div> */
    public RenderBuildPartsSelection(bps : Array<BuildPartGW>) {
        this.SetHoveredBuildPartIndex(-1)
        var elements: Array<JSX.Element> = new Array<JSX.Element>() // A holder to the build part items that will be displayed
        var key = 0

        for (var i = 0; i < bps.length; i++, key++) {
            const ind = i
            const pro = bps[i]
            const keyStr = key.toString()
            elements.push(<BuildPartQRItem key={keyStr} core={this.m_core} buildPart={pro} index={ind} />)
        }
        
        if (elements.length >= 1) {
            return <div>
                <div style={{ marginTop: "18px", marginLeft: "35px", marginBottom: "4px" }}>
                    <h2>Bygningsdeler:</h2>
                </div>
                {<div>
                    <div className="pageSection" style={{ height: "26px", width: "100%", display: "flex", flexDirection: "row", borderTop: "1px solid #B9B9B9", borderBottom: "1px solid #B9B9B9", font: "bold" }}>

                        {/* Ext Info arrowdown area */}
                        <div style={{ width: "16px" }} >
                        </div>

                        {/* Numeric control area */}
                        <div style={{ width: "120px", position: "relative", left: "20px", top: "6px" }} >
                            Antall
                        </div>
                        
                        {/* Central dynamic columns area */}
                        <div style={{ width: "calc(100% - 180px)", display: 'flex', flexDirection: 'row' }} >
                            <div style={{ width: "11%", position: "relative", top: "6px" }}></div>
                            <div style={{ width: "33%", position: "relative", top: "6px" }}>Tittel</div>
                            <div style={{ width: "29%", position: "relative", top: "6px" }}></div>
                            <div style={{ width: "15%", position: "relative", top: "6px" }}>Pris</div>
                            <div style={{ width: "10%", position: "relative", top: "6px" }}>Sum</div>
                        </div>

                        {/* Favorites star area */}
                        <div style={{ position: "relative", top: "6px" }} >
                    </div>
                    </div>
                </div>}
                <div onMouseLeave={this.onMouseLeaveArea.bind(this)} >{elements}</div>
            </div>
        }
        else {
            return <div></div>
        }
    }

    // 
    public onMouseLeaveArea() {
        this.SetHoveredBuildPartIndex(-1)
    }
    
    // 
    public OnsavedHandler(response: string) {
        const id = JSON.parse(response).id;
        this.ReloadAccountData()
    }

    // 
    public OnsavedFavoritesHandler(response: string) {
        const id = JSON.parse(response).id
    }

    // 
    public SaveProject(projectName: string, onSaved: (() => void) | null  ) {
        this.SetCurrentProjectName(projectName)
        var set = new SelectionSetGW()
        set.SetName(projectName)
        var bpset = new BuildPartSet()
        bpset.InitiateFromBuildParts(this.m_core.GetSelectedBuildParts())
        set.SetMeta("PN" + this.m_version + bpset.GetAsMetaString()) // 'P':project 'N': normal  (version: 4 numbers) + buildpartset meta data for describing owned build parts 
        Assert(this.m_core != null, "selManager.saveProject - the core reference was null!")
        set.InitFromArticles(this.m_core.GetSelectedArticles())

        // debug:
        var setstr = ""
        var testItems = set.GetSet().items
        for (var i = 0; i < testItems.length; i++) {
            setstr += "\n[id:" + testItems[i].itemId + ", amount:" + testItems[i].amount + "] "
        }

        PADebug.Debug("manager.SaveProject - dump of set items:" + setstr )

        if (onSaved == null) {
            this.SaveSelectionSet(set, set.GetId(), this.OnsavedHandler.bind(this))
        }
        else {
            this.SaveSelectionSet(set, set.GetId(), onSaved)
        }
    }

    // 
    public SaveBuildPart(buildPartName: string) {
        this.SetCurrentBuildPartName(buildPartName)
        var set = new SelectionSetGW()
        set.SetName(buildPartName)
        var bpset = new BuildPartSet()
        bpset.InitiateFromBuildParts(this.m_core.GetSelectedBuildParts())
        set.SetMeta("BN" + this.m_version + bpset.GetAsMetaString()) // 'B':buildpart 'N': normal  (version: 4 numbers)
        Assert(this.m_core != null, "selManager.saveBuildPart - the core reference was null!")
        set.InitFromArticles(this.m_core.GetSelectedArticles())
        this.SaveSelectionSet(set, set.GetId(), this.OnsavedHandler.bind(this))
    }
    
    // Stores the favorites as they are currently selected. This 
    public SaveFavorites() {
        var set = new SelectionSetGW()
        set.SetName("<Favorites>")
        set.SetMeta("FAV" + this.m_version) // 'P':project 'N': normal  (version: 4 numbers)
        Assert(this.m_core != null, "selManager.SaveFavorites - the core reference was null!")
        set.InitFromArticles(this.m_core.GetFavorites())
        this.SaveSelectionSet(set, set.GetId(), this.OnsavedFavoritesHandler.bind(this))
    }
    
    // Access : current project name
    public GetCurrentProjectName() {
        return this.m_currentProjectName
    }

    // Access : current buildpart name
    public GetCurrentBuildPartName() {
        return this.m_currentBuildPartName
    }

    // Access : current project name
    public SetCurrentProjectName(name: string) {
        this.m_currentProjectName = name
    }

    // Access : current buildpart name
    public SetCurrentBuildPartName(name: string) {
        this.m_currentBuildPartName = name
    }

    // Access : current buildpart name
    public SetCurrentProjectSummaryName(name: string) {
        this.m_currentProjectSummaryName = name
    }
    
    // Gets the index for what project item should be highlighted as hovered by the mouse
    public GetHoveredProjectIndex() {
        return this.m_hoveredProjectIndex
    }

    // Gets the index for what buildpart item should be highlighted as hovered by the mouse
    public GetHoveredBuildPartIndex() {
        return this.m_hoveredBuildPartIndex
    }
    
    // Sets the index for what project item will be highlighted as hovered by the mouse
    public SetHoveredProjectIndex(ind: number) {
        this.m_hoveredProjectIndex = ind
    }

    // Sets the index for what buildpart item will be highlighted as hovered by the mouse
    public SetHoveredBuildPartIndex(ind: number) {
        this.m_hoveredBuildPartIndex = ind
    }
    
    // Compares a chosen name for a project top be saved towards the previously saved projects. returns true if the same name already exists
    public HasPreviouslySavedProjectName(name: string) {
        for (var i = 0; i < this.m_projects.length; i++) {
            if (this.m_projects[i].GetName() == name) {
                return true
            }   
        }

        return false
    }

    // Compares a chosen name for a buildPart top be saved towards the previously saved buildparts. returns true if the same name already exists
    public HasPreviouslySavedBuildPartName(name: string) {
        for (var i = 0; i < this.m_buildParts.length; i++) {
            if (this.m_buildParts[i].GetName() == name) {
                return true
            }
        }

        return false
    }

    // onDeleteRequest handles a click on the delete project button, and will lead to a confirm deletion stage
    public onDeleteRequest(set: SelectionSetGW) {
        this.m_core.GetProjectView().SetItemToDelete(set)
        this.m_core.GetProjectView().state.stage = "deleteQuestion"
        this.m_core.GetProjectView().forceUpdate()
    }

    // onDeleteRequest handles a click on the delete project button, and will lead to a confirm deletion stage
    public onDeleteRequestBP(set: SelectionSetGW) {
        var BPView = this.m_core.GetBuildPartView()
        BPView.SetItemToDelete(set)
        const name = set.GetName()

        // Next we'll detect occurances within other build parts of the build part being deleted
        var occurances_bp = new Array<BuildPartGW>()
        var allBP = this.m_core.GetBuildParts()
        
        for (var i = 0; i < allBP.length; i++) {

            if (allBP[i].GetTitle() == name) {
                continue // Ignoring the build part being deleted
            }

            for (var j = 0; j < allBP[i].GetIncludedBuildParts().length; j++) {
                if (this.BrowseForHierarchyLoop(name, allBP[i].GetIncludedBuildParts()[j].ref) == true) {
                    occurances_bp.push(allBP[i])
                    break
                }
            }
        }

        // Affected projects will also be detected..
        var occurances_pro = new Array<BuildPartGW>()
        var allProj: BuildPartGW[] = this.m_core.GetProjectSummaries()

        for (var i = 0; i < allProj.length; i++) {
            for (var j = 0; j < allProj[i].GetIncludedBuildParts().length; j++) {
                if (this.BrowseForHierarchyLoop(name, allProj[i].GetIncludedBuildParts()[j].ref) == true) {
                    occurances_pro.push(allProj[i])
                    break
                }
            }
        }
        
        BPView.SetDeleteAffectionBPOccurances(occurances_bp)
        BPView.SetDeleteAffectionProjectOccurances(occurances_pro)
        BPView.setState({ stage: "deleteQuestion" })
    }

    // Recursion for finding loops within build part's nestled hierarchy
    BrowseForHierarchyLoop(bannedName: string, searchedBP: BuildPartGW) {
        if (searchedBP.GetTitle() == bannedName) {
            return true
        }

        var foundLoop = false

        // Recursion to find indirect occurances of the "forbidden" title
        for (var i = 0; i < searchedBP.GetIncludedBuildParts().length; i++) {
            if (this.BrowseForHierarchyLoop(bannedName, searchedBP.GetIncludedBuildParts()[i].ref) == true) {
                return true
            }
        }

        return false
    }

    // DeleteProject occurs after the user has confirmed the project deletion request and will result in the deletion of that project
    public DeleteProject(project: SelectionSetGW) {
        if (project.GetName() == this.GetCurrentProjectName()) {
            this.SetCurrentProjectNameToNew()
        }

        if (project.GetMeta().charAt(0) == "B") {
            var set = new SelectionSetGW()
            set.SetName(project.GetName())
            set.SetMeta("BD" + this.m_version) // 'B':BuildPart 'D': Deleted   (version: 4 numbers)
            Assert(this.m_core != null, "selManager.deleteProject - the core reference was null!")
            set.InitFromArticles(this.m_core.GetSelectedArticles())

            this.SaveSelectionSet(set, set.GetId(), this.onDeletedBuildPart.bind(this))
        }
        else {
            var set = new SelectionSetGW()
            set.SetName(project.GetName())
            set.SetMeta("PD" + this.m_version) // 'P':project 'D': Deleted   (version: 4 numbers)
            Assert(this.m_core != null, "selManager.deleteProject - the core reference was null!")
            set.InitFromArticles(this.m_core.GetSelectedArticles())

            PADebug.Log("manager.DeleteProject - name:" + set.GetName() + " meta:" + set.GetMeta() + " id:" + set.GetId())

            this.SaveSelectionSet(set, set.GetId(), this.onDeletedProject.bind(this))
        }
    }

    // onDeletedProject happens after a project was sucessfully deleted. It will refresh the account data and return page stage to initial again
    public onDeletedProject() {
        this.m_core.GetProjectView().setState({stage:"initial"})
        this.ReloadAccountData() 
        this.m_core.GetApp().forceUpdate() 
    }

    // onDeletedBuildPart happens after a BuildPart was sucessfully deleted. It will refresh the account data and return page stage to initial again
    public onDeletedBuildPart() {
        this.m_core.GetBuildPartView().setState({ stage: "initial" })
        this.ReloadAccountData()
        this.m_core.GetApp().forceUpdate()
    }

    // loadProject occurs when the user clicks the project load button in the project view. It will request data from the server and on recieving it trigger onLoadedProject (see below)
    public loadProject(set: SelectionSetGW) {
        if (PADebug.IsDebuging()) {
            this.m_core.DebugIncrementProjectLoadCalls()
        }

        // First we will read and put the meta data to use, where information about saved build parts can be found.
        var bset = new BuildPartSet()
        bset.InitiateFromMeta(set.GetMeta())

        var allBP = this.m_core.GetBuildParts()
        var newSel = new Array<BuildPartGW>()
        
        for (var i = 0; i < allBP.length; i++) {
            const am = bset.GetAmount(allBP[i].GetId())

            if (am == -1) {
                // This buildpart is not among the ones which should be selected, so amount is reset to 0 and it won't be inserted into the new selection
                allBP[i].SetAmount(0)
                continue
            }
            else {
                allBP[i].SetAmount(am)
                newSel.push(allBP[i])
            }
        }

        this.m_core.SetSelectedBuildParts(newSel)
        this.SetCurrentProjectName(set.GetName())
        this.SetCurrentBuildPartName(set.GetName()) // 

        LoadFromUrl(this.m_serverUrl + "api/selection/" + set.GetId() + "/complete", this.onLoadedProject.bind(this), this.m_accessToken)
        const app = this.m_core.GetApp()
        this.m_core.SetLoadingTask("project")
        app.setState({ DisplayMode: app.DMode.Loading })
    }

    // loadBuildPart uses a build part loading set to load a build part, within the process of loading all build parts
    public loadBuildPart(set?: SelectionSetGW) {
        if (PADebug.IsDebuging()) {
            this.m_core.DebugIncrementBuildPartLoadCalls()
        }

        if (set != null)
        {
            this.m_core.SetBuildPartLoadingSet(set) // Stores the set for core.OnBuildPartLoaded 
            this.SetCurrentBuildPartName(set.GetName())
            LoadFromUrl(this.m_serverUrl + "api/selection/" + set.GetId() + "/complete", this.m_core.OnBuildPartLoaded.bind(this.m_core), this.m_accessToken)
        }
    }

    // The project summary is technically a build part but which is only being used to summarise and help to display a saved project. 
    // loadProjectSummary is used to systematically load those buildparts.
    public loadProjectSummary(set?: SelectionSetGW) {
        if (set != null) {
            this.m_core.SetProjectSummaryLoadingSet(set) // Stores the set for core.OnProjectSummaryLoaded 
            this.SetCurrentProjectSummaryName(set.GetName())
            LoadFromUrl(this.m_serverUrl + "api/selection/" + set.GetId() + "/complete", this.m_core.OnProjectSummaryLoaded.bind(this.m_core), this.m_accessToken)
        }
    }

    // Handler for incoming data for a loaded project, this data will be translated into and be added as selected articles 
    public onLoadedProject(incomingData: string) {
        this.m_core.ClearAllQRArticles()
        this.m_core.onSelectionLoad(incomingData)
    }

    // Starts the process of merging a selected project (in form of a selection set) to be added on top of the existing article selection
    public mergeProject(set: SelectionSetGW) {
        // First we will read and put the meta data to use, where information about saved build parts can be found.
        var bset = new BuildPartSet()
        bset.InitiateFromMeta(set.GetMeta())

        var allBP = this.m_core.GetBuildParts()
        var result = this.m_core.GetSelectedBuildParts()

        for (var i = 0; i < allBP.length; i++) {
            const am = bset.GetAmount(allBP[i].GetId())

            if (am == -1) {
                // This buildpart is not among the ones which should be selected, so the amount is left unchanged
                continue
            }
            else {
                // First we'll check if this build part is within the selected ones or not...
                var inserted = false
                for (var r = 0; r < result.length; r++) {
                    if (result[r].GetId() == allBP[i].GetId()) {
                        result[r].AddAmount(am)
                        inserted = true
                    }
                }

                if (inserted == false) {
                    allBP[i].SetAmount(am)
                    result.push(allBP[i])
                }
            }
        }
        
        LoadFromUrl(this.m_serverUrl + "api/selection/" + set.GetId() + "/complete", this.onMergedProject.bind(this), this.m_accessToken)
        const app = this.m_core.GetApp()
        this.m_core.SetLoadingTask("project")
        app.setState({ DisplayMode: app.DMode.Loading })
    }

    // Handler for incoming data for a merged project, this data will be added to selected articles 
    public onMergedProject(incomingData: string) {
        this.m_core.onSelectionLoad(incomingData)
    }

    // Access to the latest version id of an overwritten project data set
    public GetLatestProjectVersion(id: string) {
        // first lets locate the original set:
        var originalSet : SelectionSetGW | null = null
        for (var i = 0; i < this.m_projectsUnRefined.length; i++) {
            if (this.m_projectsUnRefined[i].GetId() == id) {
                originalSet = this.m_projectsUnRefined[i]
                break
            }
        }

        if (originalSet != null) {
            const title = originalSet.GetName()
            var lastOccurance: SelectionSetGW | null = null 

            for (var i = 0; i < this.m_projectsUnRefined.length; i++) {
                if (this.m_projectsUnRefined[i].GetName() == title) {
                    lastOccurance = this.m_projectsUnRefined[i]
                }
            }

            if (lastOccurance == null) return null

            // If the latest version has D as second letter in meta, that means it is a deleted project
            if (lastOccurance.GetMeta().charAt(1) == 'D') {
                return null
            }

            return lastOccurance.GetId()
        }

        return null
    }

    // Access to the latest version id of an overwritten build part data set
    public GetLatestBuildPartVersion(id: string) {
        // first lets locate the original set:
        var originalSet: SelectionSetGW | null = null
        for (var i = 0; i < this.m_buildPartsUnRefined.length; i++) {
            if (this.m_buildPartsUnRefined[i].GetId() == id) {
                originalSet = this.m_buildPartsUnRefined[i]
                break
            }
        }

        if (originalSet != null) {
            const title = originalSet.GetName()
            var lastOccurance: SelectionSetGW | null = null
            var hasPassedOriginal = false

            for (var i = 0; i < this.m_buildPartsUnRefined.length; i++) {
                if (this.m_buildPartsUnRefined[i].GetName() == title) {
                    if (this.m_buildPartsUnRefined[i].GetId() == originalSet.GetId()) {
                        hasPassedOriginal = true
                    }

                    if (hasPassedOriginal == true) {
                        if (this.m_buildPartsUnRefined[i].GetMeta().charAt(1) == 'D') {
                            // Exception: if the set was deleted after the given ID, any "revived" item with same title won't 
                            // change that deleted status, to avoid possible bugs from items reentering the world due to the use of same title
                            // as previously deleted build parts.
                            return null
                        }
                    }

                    lastOccurance = this.m_buildPartsUnRefined[i]
                }
            }
            
            return lastOccurance
        }

        return null
    }

    // Access : version string
    public GetVersion() {
        return this.m_version
    }

    public GetVersionDisplayString() {
        const version = this.m_version

        var disp = "v"

        if (version.charAt(0) != "0") {
            disp += version.charAt(0)
        }

        disp += (version.charAt(1) + "." + version.charAt(2) )

        if (version.charAt(3) != "0") {
            disp += version.charAt(3)
        }

        return disp
    }

    public GetQRID() {
        return this.m_qrid
    }

    // Access to overwritten build part data
    // 

    private m_accessToken: ClientOAuth2.Token // the access token from the user login
    private m_core: BDKalkCore
    private m_projects: Array<SelectionSetGW>
    private m_buildParts: Array<SelectionSetGW>
    private m_projectsUnRefined: Array<SelectionSetGW>
    private m_buildPartsUnRefined: Array<SelectionSetGW>
    private m_favorites: SelectionSetGW | null
    private m_currentProjectName: string
    private m_currentBuildPartName: string
    private m_currentProjectSummaryName: string
    private m_hoveredProjectIndex: number
    private m_hoveredBuildPartIndex: number
    private m_onAccountLoaded: () => null
    private m_version: string
    private m_deletionArticle: ArticleGW
    private m_activeProjectName: string
    private m_qrid: string | null
    private m_serverUrl: string
    private m_isProjectNameSet : boolean
}



// WEBPACK FOOTER //
// ./client/view/SelectionSetManagerGW.tsx